module.exports = __webpack_public_path__ + "img/menu_volunteering.6839fca.svg";